import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

// Connects to data-controller="create-listing-from-variant"
export default class extends Controller {
  static outlets = ["polaris-autocomplete", "polaris-button"];
  static targets = ["variantIdField"];
  static values = { variantId: String };

  connect() {
    if (this.variantIdValue) {
      this.continueButtonOutlet.enable();
    }
  }

  variantIdFieldTargetConnected(target) {
    target.addEventListener(
      "polaris-autocomplete:change",
      this.onVariantChanged,
    );

    this.polarisAutocompleteOutlet.inputTarget.addEventListener(
      "input",
      this.onVariantInputChanged,
    );

    this.polarisAutocompleteOutlet.inputTarget.addEventListener(
      "blur",
      this.onVariantInputBlurred,
    );
  }

  variantIdFieldTargetDisconnected(target) {
    target.removeEventListener(
      "polaris-autocomplete:change",
      this.onVariantChanged,
    );
    if (this.hasPolarisAutocompleteOutlet) {
      this.polarisAutocompleteOutlet.inputTarget.removeEventListener(
        "input",
        this.onVariantInputChanged,
      );
      this.polarisAutocompleteOutlet.inputTarget.removeEventListener(
        "blur",
        this.onVariantInputBlurred,
      );
    }
  }

  onVariantChanged = (eventData) => {
    const variantId = eventData.detail.value;
    this.variantIdValue = variantId;

    if (this.variantIdValue) {
      this.continueButtonOutlet.enable();
    }
  };

  onVariantInputChanged = (event) => {
    if (event.target.value === "") {
      const autocompleteOutlet = this.polarisAutocompleteOutlet;

      if (autocompleteOutlet) {
        if (autocompleteOutlet.hasHiddenInputTarget) {
          autocompleteOutlet.hiddenInputTarget.value = "";
        }
        if (autocompleteOutlet.hasInputTarget) {
          autocompleteOutlet.inputTarget.value = "";
        }
      }

      this.continueButtonOutlet.disableWithoutLoader(event);
    }
  };

  onVariantInputBlurred = (event) => {
    const autocompleteOutlet = this.polarisAutocompleteOutlet;

    const selectedValue = autocompleteOutlet.hiddenInputTarget.value;

    const selectedOption = autocompleteOutlet.visibleOptions.find((option) => {
      const input = option.querySelector("input");

      return input.value === selectedValue;
    });

    if (selectedOption) {
      if (event.target.value !== selectedOption.dataset.label) {
        event.target.value = selectedOption.dataset.label;
      }
    }
  };

  handleSubmit(event) {
    this.continueButtonOutlet.disable(event);
    get(`/retailer/product_listings/new?variant_id=${this.variantIdValue}`, {
      responseKind: "turbo-stream",
    });
  }

  get continueButtonOutlet() {
    return this.polarisButtonOutlets.find(
      (outlet) => outlet.element.id === "continue-button",
    );
  }
}
